import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { adminLogin, getStoredPassword } from "../lib/admin";
import { Lock, ArrowRight } from "lucide-react";

export default function AdminLogin() {
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        // If already logged in, jump straight to dashboard
        if (getStoredPassword()) navigate("/admin");
    }, [navigate]);

    const onSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);
        try {
            const ok = await adminLogin(password.trim());
            if (ok) {
                navigate("/admin");
            } else {
                setError("Wrong password.");
            }
        } catch {
            setError("Something went wrong. Try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div data-testid="admin-login-page" className="min-h-screen flex items-center justify-center bg-[#0A0A0A] text-[#F4F4F0]">
            <div className="w-full max-w-md px-6">
                <div className="border border-white/10 p-8 space-y-7">
                    <div className="flex items-center gap-3">
                        <div className="w-10 h-10 border border-white/15 flex items-center justify-center">
                            <Lock className="h-4 w-4" strokeWidth={1.4} />
                        </div>
                        <div>
                            <div className="text-overline text-[#A3A3A3]">Studio — Restricted</div>
                            <div className="text-display text-2xl">Admin.</div>
                        </div>
                    </div>
                    <p className="text-sm text-[#A3A3A3] leading-relaxed">
                        Sign in to manage orders and use the brand assistant. This area is for SAVNT staff only.
                    </p>
                    <form onSubmit={onSubmit} className="space-y-4">
                        <div className="space-y-1.5">
                            <label className="text-overline text-[#A3A3A3]" htmlFor="admin-pwd">Password</label>
                            <input
                                id="admin-pwd"
                                type="password"
                                autoFocus
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                data-testid="admin-password-input"
                                className="w-full bg-transparent border border-white/15 px-4 py-3 text-[#F4F4F0] focus:outline-none focus:border-white/40"
                            />
                        </div>
                        {error && (
                            <div data-testid="admin-login-error" className="text-overline text-[#C25555]">{error}</div>
                        )}
                        <button
                            type="submit"
                            disabled={loading || !password}
                            data-testid="admin-login-submit"
                            className="btn-primary w-full disabled:opacity-50"
                        >
                            {loading ? "Signing in…" : "Sign in"} <ArrowRight className="h-4 w-4" />
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}
